export const prevArrow = `
    <button aria-label="Previous slide" class="slider__arrow slider__prev slick-prev button">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" class="icon icon--prev" style="transform:rotate(180deg)">
            <path d="m17.183 12.867 7.134 7.134-7.134 7.134" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
        </svg>
    </button>`;
export const nextArrow = `
    <button aria-label="Next slide" class="slider__arrow slider__next slick-next button">
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" class="icon icon--next">
            <path d="m17.183 12.867 7.134 7.134-7.134 7.134" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="3" />
        </svg>
    </button>`;

export const options = {
    slidesToShow: 3,
    swipeToSlide: true,
    infinite: false,
    cssEase: "ease",
    speed: 300,
    nextArrow,
    prevArrow,
};
